export const docsConstants = {
  GENERATE_DOCS_REQUEST: "GENERATE_DOCS_REQUEST",
  GENERATE_DOCS_SUCCESS: "GENERATE_DOCS_SUCCESS",
  GENERATE_DOCS_FAILURE: "GENERATE_DOCS_FAILURE",

  // get doc of particular user
  DOCS_LIST_REQUEST: "DOCS_LIST_REQUEST",
  DOCS_LIST_SUCCESS: "DOCS_LIST_SUCCESS",
  DOCS_LIST_FAILURE: "DOCS_LIST_FAILURE",

  DOCS_SELECT_REQUEST: "DOCS_SELECT_REQUEST",
  DOCS_SELECT_SUCCESS: "DOCS_SELECT_SUCCESS",
  DOCS_SELECT_FAILURE: "DOCS_SELECT_FAILURE",

  DOCS_LIST_ALL_REQUEST: "DOCS_LIST_ALL_REQUEST",
  DOCS_LIST_ALL_SUCCESS: "DOCS_LIST_ALL_SUCCESS",
  DOCS_LIST_ALL_FAILURE: "DOCS_LIST_ALL_FAILURE",

  TOR_COUNT_REQUEST: "TOR_COUNT_REQUEST",
  TOR_COUNT_SUCCESS: "TOR_COUNT_SUCCESS",
  TOR_COUNT_FAILURE: "TOR_COUNT_FAILURE",

  DOCS_LIST_TOR_REQUEST: "DOCS_LIST_TOR_REQUEST",
  DOCS_LIST_TOR_SUCCESS: "DOCS_LIST_TOR_SUCCESS",
  DOCS_LIST_TOR_FAILURE: "DOCS_LIST_TOR_FAILURE",

  DOCS_LIST_FILTER_REQUEST: "DOCS_LIST_FILTER_REQUEST",
  DOCS_LIST_FILTER_SUCCESS: "DOCS_LIST_FILTER_SUCCESS",
  DOCS_LIST_FILTER_FAILURE: "DOCS_LIST_FILTER_FAILURE",

  // get types of docs
  DOCS_TYPE_REQUEST: "DOCS_TYPE_REQUEST",
  DOCS_TYPE_SUCCESS: "DOCS_TYPE_SUCCESS",
  DOCS_TYPE_FAILURE: "DOCS_TYPE_FAILURE",

  // get doc category
  DOCS_CATEGORY_REQUEST: "DOCS_CATEGORY_REQUEST",
  DOCS_CATEGORY_SUCCESS: "DOCS_CATEGORY_SUCCESS",
  DOCS_CATEGORY_FAILURE: "DOCS_CATEGORY_FAILURE",

  // get docs in particular category
  CATEGORY_DOCS_REQUEST: "CATEGORY_DOCS_REQUEST",
  CATEGORY_DOCS_SUCCESS: "CATEGORY_DOCS_SUCCESS",
  CATEGORY_DOCS_FAILURE: "CATEGORY_DOCS_FAILURE",

  // get individual form contents
  DOCS_FORM_GET_REQUEST: "DOCS_FORM_GET_REQUEST",
  DOCS_FORM_GET_SUCCESS: "DOCS_FORM_GET_SUCCESS",
  DOCS_FORM_GET_FAILURE: "DOCS_FORM_GET_FAILURE",

  FORM_OPTIONS_REQUEST: "FORM_OPTIONS_REQUEST",
  FORM_OPTIONS_SUCCESS: "FORM_OPTIONS_SUCCESS",
  FORM_OPTIONS_FAILURE: "FORM_OPTIONS_FAILURE",

  // get pdf for docs
  DOCS_PDF_REQUEST: "DOCS_PDF_REQUEST",
  DOCS_PDF_SUCCESS: "DOCS_PDF_SUCCESS",
  DOCS_PDF_FAILURE: "DOCS_PDF_FAILURE",

  // get docs stats
  DOCS_STATS_REQUEST: "DOCS_STATS_REQUEST",
  DOCS_STATS_SUCCESS: "DOCS_STATS_SUCCESS",
  DOCS_STATS_FAILURE: "DOCS_STATS_FAILURE",

  // get docs stats
  DOCS_SAVE_REQUEST: "DOCS_SAVE_REQUEST",
  DOCS_SAVE_SUCCESS: "DOCS_SAVE_SUCCESS",
  DOCS_SAVE_FAILURE: "DOCS_SAVE_FAILURE",

  //submit verbal warning doc
  WARNING_DOC_SUBMIT_REQUEST: "WARNING_DOC_SUBMIT_REQUEST",
  WARNING_DOC_SUBMIT_SUCCESS: "WARNING_DOC_SUBMIT_SUCCESS",
  WARNING_DOC_SUBMIT_FAILURE: "WARNING_DOC_SUBMIT_FAILURE",

  GET_CERTIFICATES_REQUEST: "GET_CERTIFICATES_REQUEST",
  GET_CERTIFICATES_SUCCESS: "GET_CERTIFICATES_SUCCESS",
  GET_CERTIFICATES_FAILURE: "GET_CERTIFICATES_FAILURE",

  ADD_CERTIFICATE_REQUEST: "ADD_CERTIFICATE_REQUEST",
  ADD_CERTIFICATE_SUCCESS: "ADD_CERTIFICATE_SUCCESS",
  ADD_CERTIFICATE_FAILURE: "ADD_CERTIFICATE_FAILURE",

  DELETE_CERTIFICATE_REQUEST: "DELETE_CERTIFICATE_REQUEST",
  DELETE_CERTIFICATE_SUCCESS: "DELETE_CERTIFICATE_SUCCESS",
  DELETE_CERTIFICATE_FAILURE: "DELETE_CERTIFICATE_FAILURE",

  DELETE_DOCUMENT_REQUEST: "DELETE_DOCUMENT_REQUEST",
  DELETE_DOCUMENT_SUCCESS: "DELETE_DOCUMENT_SUCCESS",
  DELETE_DOCUMENT_FAILURE: "DELETE_DOCUMENT_FAILURE",
};

export const docStatusConstants = {
  STARTED_FILLING: 1,
  IN_REVIEW: 2,
  COMPLETE: 3
};

export const documentTypes={
  Onboarding:1,
  Rehire:2,
  Other:3,
  GISS_Onboarding:4,
  GISS_Rehire:5,
};

/** Matches streamlined onboarding in `firestorm/config/documents.php` (slug = doc type name kebab-case). */
export const STREAMLINED_ONBOARDING_DOC_SLUGS = [
  "employee-information-page",
  "w-4",
  "state-tax",
  "i-9",
  "disclosure-statement-work-agreement",
  "disclosure-of-background-information-and-final-company-policy-acknowledgement",
  "fwfs-employee-handbook-acknowledgement-of-receipt",
  "dcr-employee-handbook-acknowledge-of-receipt",
];

export const STREAMLINED_ONBOARDING_DOC_SLUGS_SET = new Set(
  STREAMLINED_ONBOARDING_DOC_SLUGS,
);

export function isStreamlinedOnboardingSlug(slug) {
  return STREAMLINED_ONBOARDING_DOC_SLUGS_SET.has(slug);
}

export function filterStreamlinedOnboardingDocsInOrder(docs) {
  return [...docs].sort(
    (a, b) =>
      STREAMLINED_ONBOARDING_DOC_SLUGS.indexOf(a.slug) -
      STREAMLINED_ONBOARDING_DOC_SLUGS.indexOf(b.slug),
  );
}

/** Last step in the streamlined flow that exists for this user/category. */
export function getStreamlinedOnboardingLastSlug(userDocs, categoryId) {
  const inCategory = (userDocs || []).filter(
    (d) => Number(d.docs_categories_id) === Number(categoryId),
  );
  const allowed = inCategory.filter((d) => isStreamlinedOnboardingSlug(d.slug));
  if (!allowed.length) {
    return null;
  }
  const order = STREAMLINED_ONBOARDING_DOC_SLUGS;
  let lastSlug = null;
  let lastIdx = -1;
  allowed.forEach((d) => {
    const idx = order.indexOf(d.slug);
    if (idx > lastIdx) {
      lastIdx = idx;
      lastSlug = d.slug;
    }
  });
  return lastSlug;
}